// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
interface ScoutOptions {
          appKey: string;
          appId: string;
          userId?: string | (() => string);
          userName?: string | (() => string);
          publicPath?: string[];
        }

      declare global {
        interface Window {
          Scout: ScoutInstance;
          __scout_pre_error_queue__?: Array<{
            type: string;
            payload: any;
          }>;
        }
      }

      interface ScoutInstance {
        init(options: ScoutOptions): Promise<void>;
        setUserData(data: Record<string, any>): Promise<void>;
        setMetaData(data: Record<string, any>): Promise<void>;
        captureError(error: Error, metadata?: object): void;
        captureMessage(message: string, level?: string): void;
        logger: {
          log(message: string): void;
          info(message: string): void;
          error(message: string): void;
          warning(message: string): void;
          verbose(message: string): void;
          trace(message: string): void;
        };
      }

      let appScout: ScoutInstance = window.Scout;

      // 降级
      const fallbackInstance = {
        init: () => Promise.resolve(),
        setUserData: () => Promise.resolve(),
        setMetaData: () => Promise.resolve(),
        captureError: () => {},
        captureMessage: () => {},
        logger: {
          log: () => {},
          info: () => {},
          error: () => {},
          warning: () => {},
          verbose: () => {},
          trace: () => {},
        },
      } as ScoutInstance;

      // 确保再非浏览器环境下不会报错
      if (!globalThis.Scout) {
        console.warn('Scout SDK not initialized yet');
        appScout = fallbackInstance;
      }

      // 同步捕获错误的方法
      const captureErrorSync = async (error: Error, metadata?: object) => {
        if (typeof window === 'undefined') return;

        try {
          appScout?.captureError(error, metadata);
        } catch (err) {
          if (window.__scout_pre_error_queue__) {
            window.__scout_pre_error_queue__.push({
              type: 'error',
              payload: { error, metadata },
            });
          }
        }
      };

      export { appScout, captureErrorSync };
